export default {
  'formandstep-form.basic.title': '基础表单',
  'formandstep-form.basic.description':
    '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',

  'formandstep-form.email.required': '请输入邮箱地址！',
  'formandstep-form.email.wrong-format': '邮箱地址格式错误！',
  'formandstep-form.userName.required': '请输入用户名!',
  'formandstep-form.password.required': '请输入密码！',
  'formandstep-form.password.twice': '两次输入的密码不匹配!',
  'formandstep-form.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'formandstep-form.strength.strong': '强度：强',
  'formandstep-form.strength.medium': '强度：中',
  'formandstep-form.strength.short': '强度：太短',
  'formandstep-form.confirm-password.required': '请确认密码！',
  'formandstep-form.phone-number.required': '请输入手机号！',
  'formandstep-form.phone-number.wrong-format': '手机号格式错误！',
  'formandstep-form.verification-code.required': '请输入验证码！',
  'formandstep-form.title.required': '请输入标题',
  'formandstep-form.date.required': '请选择起止日期',
  'formandstep-form.goal.required': '请输入目标描述',
  'formandstep-form.standard.required': '请输入衡量标准',

  'formandstep-form.form.get-captcha': '获取验证码',
  'formandstep-form.captcha.second': '秒',
  'formandstep-form.form.optional': '（选填）',
  'formandstep-form.form.submit': '提交',
  'formandstep-form.form.save': '保存',
  'formandstep-form.email.placeholder': '邮箱',
  'formandstep-form.password.placeholder': '至少6位密码，区分大小写',
  'formandstep-form.confirm-password.placeholder': '确认密码',
  'formandstep-form.phone-number.placeholder': '手机号',
  'formandstep-form.verification-code.placeholder': '验证码',
  'formandstep-form.title.label': '标题',
  'formandstep-form.title.placeholder': '给目标起个名字',
  'formandstep-form.date.label': '起止日期',
  'formandstep-form.placeholder.start': '开始日期',
  'formandstep-form.placeholder.end': '结束日期',
  'formandstep-form.goal.label': '目标描述',
  'formandstep-form.goal.placeholder': '请输入你的阶段性工作目标',
  'formandstep-form.standard.label': '衡量标准',
  'formandstep-form.standard.placeholder': '请输入衡量标准',
  'formandstep-form.client.label': '客户',
  'formandstep-form.label.tooltip': '目标的服务对象',
  'formandstep-form.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'formandstep-form.invites.label': '邀评人',
  'formandstep-form.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'formandstep-form.weight.label': '权重',
  'formandstep-form.weight.placeholder': '请输入',
  'formandstep-form.public.label': '目标公开',
  'formandstep-form.label.help': '客户、邀评人默认被分享',
  'formandstep-form.radio.public': '公开',
  'formandstep-form.radio.partially-public': '部分公开',
  'formandstep-form.radio.private': '不公开',
  'formandstep-form.publicUsers.placeholder': '公开给',
  'formandstep-form.option.A': '同事甲',
  'formandstep-form.option.B': '同事乙',
  'formandstep-form.option.C': '同事丙',
};
